import { render, staticRenderFns } from "./private-league.vue?vue&type=template&id=273a25c1&"
import script from "./private-league.vue?vue&type=script&lang=js&"
export * from "./private-league.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports